import { t } from "i18next"
import { z } from "zod"
import { ConsultationFeedbackReason, ConsultationFeedbackReasonValues } from "@/types/__generated__/union-types"

const FeedbackSchema = z
  .object({
    likedConsultation: z.boolean(),
    reason: z.custom<ConsultationFeedbackReason>().optional(),
    otherReasonText: z.string().optional(),
  })
  .superRefine(({ likedConsultation, reason, otherReasonText }, ctx) => {
    if (!likedConsultation) {
      if (!reason) {
        ctx.addIssue({
          code: "custom",
          path: ["reason"],
          message: t("common.fieldErrorList.requiredField"),
        })
      }
      if (reason === "OTHER") {
        if (!otherReasonText || otherReasonText.length < 5) {
          ctx.addIssue({
            code: "custom",
            path: ["otherReasonText"],
            message: t("patient.conclude.feedback.otherReasonMinLength"),
          })
        }
        if (otherReasonText && otherReasonText.length > 100) {
          ctx.addIssue({
            code: "custom",
            path: ["otherReasonText"],
            message: t("patient.conclude.feedback.otherReasonMaxLength"),
          })
        }
      }
    }
  })

type FeedbackSchemaType = z.infer<typeof FeedbackSchema>

export { ConsultationFeedbackReasonValues, FeedbackSchema, type FeedbackSchemaType }
